import styled from 'styled-components';
import { isIE11 } from '../../helpers/utils-helpers';

const link = `
  cursor: pointer;
  display: inline-block;
  color: #333d6c;
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  text-decoration: underline;

  &:hover {
    opacity: .8;
  }
`;

export const IntegrationSC = styled.div`
  .help-link {
    ${link}

    margin-bottom: 50px;
    margin-top: 17px;
  }

  .other-software {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 24px;
    padding-bottom: 20px;
    border-bottom: 1px solid #d7d9e2;

    p {
      ${isIE11 ? 'max-width: 300px;' : 'margin-right: 21px;'}

      margin-bottom: 0;
    }
  }

  .input-with-btn {
    position: relative;

    .copy-label {
      ${link}

      position: absolute;
      top: 16px;
      right: 20px;
    }
  }
`;

export const IntegrationOpsSC = styled.div`
  display: flex;
  margin-bottom: 24px;
  border: 1px solid #d7d9e2;
  border-radius: 10px;
  flex-wrap: wrap;

  > div {
    width: 50%;
    padding: 24px 16px 16px;

    &:not(:last-child) {
      border-right: 1px solid #d7d9e2;
    }

    &:nth-child(1) {
      border-bottom: 1px solid #d7d9e2;
    }

    &:nth-child(2) {
      border-right: none;
      border-bottom: 1px solid #d7d9e2;
    }

    &.disabled {
      opacity: 0.4;
    }
  }

  h3 {
    line-height: 32px;
    font-size: 24px;
    color: #141b38;
    font-weight: 700;
    margin: 0;
  }

  p {
    margin-bottom: 30px;
  }
`;

export const IntegrationBackSC = styled.div`
  margin-bottom: 24px;
  cursor: pointer;
  transition: opacity 0.2s;

  .span {
    display: inline-flex;
  }

  img {
    margin-right: 12px;
  }

  &:hover {
    opacity: 0.8;
  }
`;
